<template>
  <div class="backdrop" role="presentation">
    <Square />
    <span class="loading-term" v-if="loadingTermValue">{{ loadingTermValue }}</span>
    <div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">
      {{ announcedValue }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, ref, onMounted } from 'vue';
import Square from './Square.vue';

export default defineComponent({
  name: 'Loader',
  components: { Square },
  props: {
    loadingTermValue: {
      type: String,
      default: 'Loading',
    },
  },
  setup(props) {
    const announcedValue = ref('');
    const updateAnnouncement = () => {
      announcedValue.value = '';
      setTimeout(() => {
        announcedValue.value = props.loadingTermValue || 'Loading';
      }, 100);
    };

    onMounted(updateAnnouncement);
    watch(() => props.loadingTermValue, updateAnnouncement);

    return {
      announcedValue,
    };
  },
});
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 4;
}

.loading-term {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 150%);

  &:first-letter {
    text-transform: uppercase;
  }
}

.sr-only {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
